import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Typography, Box, TextField, Grid, Button, Autocomplete } from "@mui/material";
import { postData } from "src/views/utilities/api";
import { redirectUrl } from "src/config";
import { useSnackBar } from "src/context/SnackBarContext";
import Loader from "src/components/Loader";

function AddPlanMaster({ onClose, refetch, editData }) {
  
  const { showSnackbar } = useSnackBar();
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState(
    {plan_name:"",
      days:'',
      qty:"",
      price:"",
      offer_price:"",
      status:""
    }
    );
    
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setLoading(true);
    if (editData?.plan_name) {
      try {

        setPlan(editData);
        setEditMode(true);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
    setLoading(false);
  }, [editData]);


  const handleChange = (event) => {
    const { name, value } = event.target;
    setPlan({ ...plan, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!plan.plan_name) newErrors.plan_name = "Name is required.";
    if (!plan.price) newErrors.price = "price is required.";
    if (!plan.days) newErrors.days = "days is required.";
    if (!plan.status) newErrors.days = "status is required.";
    if (!plan.qty) newErrors.days = "qty is required.";



    // if (!uploaded) newErrors.file = "Image is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true); // Start loading



    try {
      const response = !editMode
        ? await postData(`/api/addUsersPlanMaster`, plan)
        : await postData(`/api/updateUsersPlanMaster`, plan);

      if (response.success) {
        showSnackbar("success", response.message);
        refetch();
        onClose();
      } else {
        showSnackbar("error", response.message);
      }
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        window.location.href = redirectUrl;
      }
      showSnackbar("error", "Error saving Plan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 1 }} component="form" onSubmit={handleSave}>
      <Loader start={loading} />
      <Typography variant="h6">{editMode ? "Update Plan" : "Create Plan"}</Typography>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <TextField
            required
            value={plan.plan_name}
            fullWidth
            placeholder="Type Plan name here..."
            label="Name"
            name="plan_name"
            variant="outlined"
            onChange={handleChange}
            error={!!errors.plan_name}
            helperText={errors.plan_name}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            value={plan.price}
            fullWidth
            placeholder="Type Price here..."
            label="Price"
            name="price"
            variant="outlined"
            onChange={handleChange}
            error={!!errors.price}
            helperText={errors.price}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
       
            value={plan.offer_price}
            fullWidth
            placeholder="Type Offer Price here..."
            label="Offer Price"
            name="offer_price"
            variant="outlined"
            onChange={handleChange}

          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            value={plan.days}
            fullWidth
            placeholder="Type Duration here..."
            label="Duration"
            name="days"
            variant="outlined"
            onChange={handleChange}
            error={!!errors.days}
            helperText={errors.days}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            value={plan.qty}
            fullWidth
            placeholder="Type no of Qty here..."
            label="Qty"
            name="qty"
            variant="outlined"
            onChange={handleChange}
            error={!!errors.qty}
            helperText={errors.qty}
          />
        </Grid>
        <Grid item xs={12} md={6}>
                  <Autocomplete
                    disablePortal
                    clearIcon
                    
                    options={["Active","Inactive"]}
                    getOptionLabel={(option) => option}
                    onChange={(e,value)=>setPlan({ ...plan, status: value })}
                    value={plan.status}
                    
                    name="status"
                    fullWidth
                    error={!!errors.status}
            helperText={errors.status}
                    renderInput={(params) => <TextField {...params} value={plan.status} label="Choose Status" />}
                  />
                </Grid>

   


        <Grid item xs={6}>
          <Button type="submit" fullWidth variant="contained" color="success">
            {!editMode ? "Save" : "Update"}
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Button
            fullWidth
            variant="outlined"
            color="warning"
            onClick={() => onClose()}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

AddPlanMaster.propTypes = {
  onClose: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  editData: PropTypes.object,
};

export default AddPlanMaster;
